import { Modal, Descriptions, Select } from "antd";
import { useGetUsers } from "apis/user";
import React, { useState, useEffect } from "react";
import { ScreenSize } from "utils/constants";
import Locale from "react-intl-universal";

function PicModal(props) {
  const {
    visible,
    HandleAssignPic,
    setSelectAssignPic,
    setVisible,
    adviseeUser,
    selectAssignPic,
  } = props;

  var GetPic = useGetUsers({ currentPage: 1, limit: null });

  return (
    <Modal
      title={Locale.get("leadDashboard.assignPic.picAssign")}
      visible={visible}
      onOk={HandleAssignPic}
      onCancel={() => {
        setSelectAssignPic(null);
        setVisible(false);
      }}
      width={window.innerWidth < ScreenSize.xl ? "100%" : 1200}
    >
      <Descriptions
        layout="vertical"
        size="small"
        column={{ xs: 1, md: 2, xl: 3 }}
        // column={3}
        bordered
      >
        <Descriptions.Item
          style={{ fontSize: 16 }}
          label={
            <span style={{ fontWeight: 600 }}>
              {Locale.get("leadDashboard.expandableRow.name")}
            </span>
          }
        >
          {adviseeUser.name}
        </Descriptions.Item>
        <Descriptions.Item
          style={{ fontSize: 16 }}
          label={
            <span style={{ fontWeight: 600 }}>
              {Locale.get("leadDashboard.expandableRow.dob")}
            </span>
          }
        >
          {adviseeUser.dob}
        </Descriptions.Item>
        <Descriptions.Item
          style={{ fontSize: 16 }}
          label={
            <span style={{ fontWeight: 600 }}>
              {Locale.get("leadDashboard.expandableRow.contact")}
            </span>
          }
        >
          {adviseeUser.contact}
        </Descriptions.Item>
        <Descriptions.Item
          style={{ fontSize: 16 }}
          label={
            <span style={{ fontWeight: 600 }}>
              {Locale.get("leadDashboard.assignPic.dos")}
            </span>
          }
        >
          {adviseeUser.createdAt}
        </Descriptions.Item>
        <Descriptions.Item
          style={{ fontSize: 16 }}
          label={
            <span style={{ fontWeight: 600 }}>
              {Locale.get("leadDashboard.assignPic.currentPic")}
            </span>
          }
        >
          {adviseeUser.assignedTo}
        </Descriptions.Item>
        <Descriptions.Item
          style={{ fontSize: 16 }}
          label={
            <span style={{ fontWeight: 600 }}>
              {Locale.get("leadDashboard.assignPic.assignNewPic")}
            </span>
          }
        >
          <Select
            placeholder={Locale.get("leadDashboard.assignPic.picPlaceholder")}
            value={selectAssignPic}
            filterOption={(searchInput, option) => {
              // console.log(searchInput, option);
              const regex = new RegExp(searchInput, "i");
              // console.log(option.children && regex.test(option.children));
              return option.children && regex.test(option.children);
            }}
            showSearch
            style={{ width: "100%" }}
            onChange={(e) => setSelectAssignPic(e)}
          >
            {GetPic?.paginatedData?.map((pic) => {
              return (
                <Select.Option key={pic._id} value={pic._id}>
                  {pic.name}
                </Select.Option>
              );
            })}
          </Select>
        </Descriptions.Item>
      </Descriptions>
    </Modal>
  );
}

export default PicModal;
